<template>
  <div>
    <h1 class="modal-h1 mb-3">
      <button type="button"
              class="btn btn-back"
              @click="$emit('cancel')"
      />
      Create Customer
    </h1>
    <form @submit.prevent="create"
          @keydown="clearError($event)"
          autocomplete="no"
    >
      <div class="l-bg-white">
        <div class="row mb-3">
          <div class="col-6 pl-1 pr-1">
            <div class="select-wrap">
              <label>Company</label>
              <simple-select v-model="customer.company_id"
                             :options="companies"
                             placeholder="Select Company"
              />
            </div>
            <error-field :errors="errors" field="company_id" />
          </div>
        </div>
        <div class="row mb-3">
          <div class="col-6 pl-1 pr-1">
            <div class="select-wrap">
              <label>First name</label>
              <input v-model="customer.first_name"
                     type="text"
                     placeholder="Enter First Name"
                     autocomplete="no"
                     class="form-control"
              />
            </div>
            <error-field :errors="errors" field="first_name" />
          </div>
          <div class="col-6 pl-1 pr-1">
            <div class="select-wrap">
              <label>Last name</label>
              <input v-model="customer.last_name"
                     type="text"
                     placeholder="Enter Last Name"
                     autocomplete="no"
                     class="form-control"
              />
            </div>
            <error-field :errors="errors" field="last_name" />
          </div>
        </div>
        <div class="row mb-3">
          <div class="col-6 pl-1 pr-1">
            <div class="select-wrap">
              <label>Email</label>
              <input v-model="customer.email"
                     type="email"
                     placeholder="Enter Email"
                     autocomplete="no"
                     class="form-control"
              />
            </div>
            <error-field :errors="errors" field="email" />
          </div>
          <div class="col-6 pl-1 pr-1">
            <div class="select-wrap">
              <label>Phone</label>
              <input v-model="customer.phone"
                     type="text"
                     class="form-control"
                     @keydown="maskPhone"
                     placeholder="Enter Phone"
                     autocomplete="no"
                     maxlength="14"
              />
            </div>
            <error-field :errors="errors" field="phone" />
          </div>
        </div>
        <!-- Additional contacts -->
        <div v-for="(contact, index) in customer.contacts"
             :key="contact.id"
        >
          <div class="row" v-if="index === 0">
            <div class="col-md-12 mb-0">
              <h4>Additional Contacts</h4>
            </div>
          </div>
          <div class="row mb-3">
            <div class="col-5 pl-1 pr-1">
              <div class="select-wrap">
                <label>Email</label>
                <input v-model="contact.email"
                       type="email"
                       placeholder="Enter Email"
                       autocomplete="no"
                       class="form-control"
                />
              </div>
              <error-field :errors="errors" :field="`contacts.${index}.email`" />
            </div>
            <div class="col-5 pl-1 pr-1">
              <div class="select-wrap">
                <label>Phone</label>
                <input v-model="contact.phone"
                       type="text"
                       placeholder="Enter Phone"
                       autocomplete="no"
                       class="form-control"
                />
              </div>
              <error-field :errors="errors" :field="`contacts.${index}.phone`" />
            </div>
            <div class="col-1 pr-0 pl-5 pt-3 text-right">
              <button type="button"
                      class="btn btn-clear p-1"
                      @click="removeContact(index)"
              >
                <i class="fa fa-times" />
              </button>
            </div>
          </div>
        </div>
        <div class="row mt-3">
          <div class="col">
            <button type="button"
                    class="btn add-button"
                    @click="addAdditionalContact"
            >
              <span><i class="fa fa-plus" aria-hidden="true" /></span>
              Add additional contact
            </button>
          </div>
        </div>
        <div class="row">
          <div class="col-md">
            <error-field :errors="errors" field="authorization" class="mt-3" />
          </div>
        </div>
        <div class="row mt-5">
          <div class="col">
            <button class="btn btn-primary float-right ld-ext-right"
                    :class="loadingButton ? 'running' : ''"
                    :disabled="buttonDisabled"
            >
              Create
              <div class="ld ld-ball ld-flip" />
            </button>
          </div>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
import axios from 'axios';
import { mapState } from 'vuex';
import toastr from 'toastr';
import Errors from '../../classes/Errors';
import ErrorField from '../ErrorField';
import PhoneMask from '../../classes/PhoneMask';

export default {
  components: {
    ErrorField,
  },
  data: () => ({
    customer: {
      first_name: '',
      last_name: '',
      email: '',
      phone: '',
      contacts: [],
    },
    loadingButton: false,
    buttonDisabled: false,
    phoneMask: new PhoneMask(),
    errors: new Errors(),
  }),
  computed: {
    ...mapState({
      companies: state => state.companies.companies.data,
    }),
  },
  methods: {
    create() {
      this.buttonDisabled = true;
      this.loadingButton = true;
      axios
        .post('customers/create', { ...this.customer })
        .then(() => {
          toastr.success('Successfully created customer');
          this.$emit('update');
          this.$emit('cancel');
        })
        .catch(err => {
          this.errors.record(err.response.data.error);
        })
        .finally(() => {
          this.loadingButton = false;
          this.buttonDisabled = false;
        });
    },
    clearError(event) {
      this.errors.clear(event.target.name);
    },
    addAdditionalContact() {
      this.customer.contacts.push({
        email: '',
        phone: '',
      });
    },
    removeContact(index) {
      this.customer.contacts.splice(index, 1);
    },
    maskPhone() {
      this.$nextTick(() => {
        this.$set(this.customer, 'phone', this.phoneMask.maskedPhone(this.customer.phone));
      });
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/customers/CustomersCreate.vue